import translate from '@/services/translate';

function getFinalSeparatorPath(separatorAlias) {
  if (separatorAlias === 'and') {
    return 'general.and';
  }

  if (separatorAlias === 'or') {
    return 'general.or';
  }

  return separatorAlias;
}

/**
 * Faz um join gramatical em uma array, concatenando um separador diferente no último elemento, como
 * "e" ou "ou".
 * @example
 *   expect(grammaticalJoin(['azul', 'verde', 'roxo', 'cinza'])).toBe('azul, verde, roxo e cinza')
 * @param {Array} array Array a ser concatenada.
 * @param {String} separator Separador. Padrão vírgula.
 * @param {String} finalSeparatorPath Path para tradução para último separador.
 *   Padrão 'and'. Para facilidade, suporta os apelidos "and" e "or" apontando para "general.and" e
 *   "general.or" respectivamente.
 */
// eslint-disable-next-line import/prefer-default-export
export function grammaticalJoin(array, {
  separator = ',',
  finalSeparatorPath = 'and',
} = {}) {
  if (array.length === 1) {
    return array[0];
  }
  const arrayExceptLast = array.slice(0, array.length - 1).join(`${separator} `);
  const last = array[array.length - 1];
  return `${arrayExceptLast} ${translate(getFinalSeparatorPath(finalSeparatorPath))} ${last}`;
}

export function isSameArray(list, prop) {
  if (!(list || []).length) {
    return true;
  }

  const [firstValue] = (list[0][prop] || []);

  for (let index = 0; index < list.length; index += 1) {
    const isAllEquals = (list[index][prop] || [])
      .slice()
      .sort()
      .every(item => item === firstValue);

    if (!isAllEquals) {
      return false;
    }
  }

  return true;
}

/**
 * Mapeia um array de objetos para um array com seus ids
 * @param {Array} array array de objetos que contenham um id
 * @returns Array de id's dos objetos do array
 */
export function mapArrayIds(array) {
  return (array || []).map(item => item.id);
}
